module.exports = __webpack_public_path__ + "static/politica-qualita-materia3-93b0c633562ac2ea578c4302e4b59270.pdf";